import {Skeleton} from '@ds/components';

const SubCategoriesSkeleton: React.FC = () => {
  return (
    <div className="flex gap-2">
      <Skeleton.Button active size="small" className="h-8 w-20 rounded-full" />
      <Skeleton.Button active size="small" className="h-8 w-30 rounded-full" />
      <Skeleton.Button active size="small" className="h-8 w-15 rounded-full" />
      <Skeleton.Button active size="small" className="h-8 w-30 rounded-full" />
      <Skeleton.Button active size="small" className="h-8 w-20 rounded-full" />
    </div>
  );
};

export default SubCategoriesSkeleton;
